﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as React from "react";
import { createUseStyles } from "react-jss";
import LocalePicker from "~base/Pages/Shared/LocalePicker";
import { useIntl } from "~base/Internationalization/IntlContext";
import { useSettings } from "~base/Settings/SettingsContext";
import type { SoPNLConsilioTheme } from "~jrad/Styling/SoPNLConsilioTheme";

//-------------------------------------------------------------------------------------
// Props
//-------------------------------------------------------------------------------------

export interface SelfServiceHeaderMenuProps {}

const useStyles = createUseStyles((theme: SoPNLConsilioTheme) => ({
    menu: {
        display: "flex",
        flexDirection: "row",
        columnGap: "10px",
        alignItems: "center",
    },
    menuItem: {},
    languageLabel: {
        fontFamily: theme.constants.defaultFont,
        fontSize: "14px",
        color: theme.constants.textColor,
        whiteSpace: "nowrap",
        fontWeight: "bold",
    },
}));

//-------------------------------------------------------------------------------------
// Component
//-------------------------------------------------------------------------------------

const SelfServiceHeaderMenu: React.FunctionComponent<
    SelfServiceHeaderMenuProps
> = () => {
    const intl = useIntl();
    const classes = useStyles();
    const settings = useSettings();

    const languages = settings
        .valueAsStringArray("Cultures")
        .map((lang) => (lang === "en-NL" ? "en-US" : lang));
    const defaultLanguage = settings.valueAsString("account.defaultLanguage");

    return (
        <div className={classes.menu}>
            <span className={classes.languageLabel}>
                {intl.formatText(
                    "SoPNL.UI.SelfServiceLogin.SelectLanguage.Label"
                )}
            </span>
            <div className={classes.menuItem}>
                <LocalePicker
                    defaultLanguage={defaultLanguage}
                    enabledLanguages={languages}
                />
            </div>
        </div>
    );
};

export default SelfServiceHeaderMenu;
